export default __webpack_public_path__ + "static/media/i-arrow-down.ffb6c1c9.svg";